export function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}

export function Android() {
  return /(android)/i.test(navigator.userAgent)
}

export const MOUSEWHEEL = 'mousewheel DOMMouseScroll wheel MozMousePixelScroll'

export function CoreDetect_WebP() {
  const WebP = new Image()
  WebP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
  WebP.onload = WebP.onerror = function() {
    if (WebP.height === 2) {
      document.documentElement.classList.add('has-webp')
      return true
    } else {
      document.documentElement.classList.add('no-webp')
      return false
    }
  }
}
